import { FC, useEffect } from 'react';
import { SimpleForm, useAuthProvider } from 'react-admin';
import { Container, Box, Stack } from '@mui/material';
import { ScheduleSidebar } from './ScheduleSidebar/ScheduleSidebar';
import { TabbedScheduleCalendar } from './ScheduleCalendar/TabbedScheduleCalendar';
import { useScheduleCalendarContext } from '../common/context/CalendarContext';
import axiosApiInstance from 'src/api/axiosConfig';
import { EducationCenterType } from 'src/components/Employees/types';
import { WithRole } from 'src/components/common';
import { AdminNoSecretariatGroup } from 'src/constants/roles';

const fetchEducationCenter = async (id: number): Promise<EducationCenterType> => {
    const { data } = await axiosApiInstance.get(`centers/${id}`);

    return data;
};

export const ScheduleListView: FC = () => {
    const { calendarConfig, setCalendarData } = useScheduleCalendarContext();
    const { getEducationCenterId } = useAuthProvider();

    useEffect(() => {
        if (getEducationCenterId()) {
            fetchEducationCenter(getEducationCenterId()).then((educationCenter) => {
                setCalendarData((data) => ({ ...data, educationCenter }));
            });
        }
    }, []);

    const styleContainer = { backgroundColor: 'inherit', margin: 0, padding: '35px 16px' };

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <SimpleForm toolbar={false} sx={{ padding: 0 }}>
                <Stack direction={'row'}>
                    <WithRole roles={AdminNoSecretariatGroup}>
                        {!calendarConfig.viewMode && (
                            <Container sx={{ padding: '16px 8px', width: '285px', backgroundColor: 'white' }}>
                                <ScheduleSidebar />
                            </Container>
                        )}
                    </WithRole>
                    <Container
                        sx={{
                            ...styleContainer,
                            '@media (min-width: 1200px)': {
                                maxWidth: 'fit-content'
                            },
                            '@media (min-width: 600px)': {
                                padding: styleContainer.padding
                            }
                        }}>
                        <TabbedScheduleCalendar />
                    </Container>
                </Stack>
            </SimpleForm>
        </Box>
    );
};
